function o(r){return[...r].reduce((e,[n,t])=>(e[n]=t,e),{})}export{o as fromEntries};
